import { useAuth0 } from "@auth0/auth0-react";
import { tryCatchWrapper } from "helpers/common";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchRoles } from "redux/actions/portal/rolesActionCreator";

export const useRoles = (shouldFetch = true) => {
  const { user } = useAuth0();
  const { roles } = useSelector((store) => store.portal.roles);
  const dispatch = useDispatch();

  const handleFetchRoles = async () => {
    if (!user) return;

    dispatch(fetchRoles(user.stripeId));
  };

  useEffect(() => {
    if (!user || roles?.length || !shouldFetch) return;

    tryCatchWrapper(handleFetchRoles)();
  }, [user]);

  return {
    roles,
    handleFetchRoles
  };
};
